import { createSlice } from "@reduxjs/toolkit";

export const adminSlice = createSlice({
  name: "adminReducer",
  initialState: {
    investmentVehicles: {},
    recordKeepers: {},
    productManufacturers: {},
    insuranceCompanies: {},
  },
  reducers: {
    setInvestmentVehiclesData: (state, action) => {
      state.investmentVehicles = action.payload;
    },
    setRecordKeepersData: (state, action) => {
      state.recordKeepers = action.payload;
    },
    setProductManufacturersData: (state, action) => {
      state.productManufacturers = action.payload;
    },
    setInsuranceCompaniesData: (state, action) => {
      state.insuranceCompanies = action.payload;
    },
  },
});

export const {
  setInvestmentVehiclesData,
  setRecordKeepersData,
  setProductManufacturersData,
  setInsuranceCompaniesData,
} = adminSlice.actions;
export default adminSlice.reducer;
